import api from './api'

export async function getBackEndVersion(): Promise<string> {
  const response = await api.get('/version')
  const { version } = response.data

  return version
}
